export const DecorationMethods = {
  DEBOSSED: 'debossed',
  EMBOSSED: 'embossed',
  LASER_ENGRAVED: 'laser engraved',
  LASER_ETCHED: 'laser etched',
  SCREEN: 'screen'
};
